import router from "@/router";
import { constants } from "../constant/constants";
import { clearDpopState } from "../services/dpop/dpop-sign-out";
import { LocalStorageService } from "./local-storage-service";

export module UrlHelper {
  export function buildUrl(url: any, parameters: any) {
    let qs = "";
    for (const key in parameters) {
      if (parameters.hasOwnProperty(key)) {
        const value = parameters[key];
        qs += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
      }
    }
    if (qs.length > 0) {
      qs = qs.slice(0, -1); //chop off last "&"
      url = url + "?" + qs;
    }

    return url;
  }

  export function redirectToSignIn() {
    // The session is over, so its DPoP key goes too (best effort, never waited on).
    void clearDpopState();
    const cxAppSettingsString = localStorage.getItem(
      constants.localStorage.keys.cxappsettings,
    );
    localStorage.clear();
    if (cxAppSettingsString) {
      LocalStorageService.setItem(
        constants.localStorage.keys.cxappsettings,
        cxAppSettingsString,
      );
    }

    localStorage.setItem("magic-link-auth-error", "redirectToSignIn");

    if (router.currentRoute.value.name !== "Login") {
      void router.push({ name: "Login" });
    }
  }

  /** Hash pathname only (no `#`, no query), e.g. `#/doc/public/abc?x=1` → `/doc/public/abc`. */
  function getHashPathname(): string {
    const hash = window.location.hash || "";
    const pathAndSearch = hash.startsWith("#") ? hash.slice(1) : hash;
    const pathname = pathAndSearch.split("?")[0] || "/";
    return pathname.startsWith("/") ? pathname : `/${pathname}`;
  }

  /**
   * Anonymous shared-document links only (`/doc/public/:contentId` with a single id segment).
   * Intentionally does not use the router: `router.isReady()` must not run before `app.use(router)`.
   */
  export function isPublicURL() {
    const path = getHashPathname().toLowerCase();
    return /^\/doc\/public\/[^/]+$/.test(path);
  }

  export function isAuthVerificationURL() {
    const href = (window.location.href || "").toLowerCase();
    const hash = (window.location.hash || "").toLowerCase();
    return href.includes("/auth/verify?") || hash.includes("/auth/verify?");
  }
}
